function postMessageToParentWindow(parentWindow, type, payload, targetOrigin) {
    parentWindow.postMessage(
        {
            type,
            data: payload,
        },
        targetOrigin,
    )
}

const postMessageToParentWindowPromise = (parentWindow, type, payload, targetOrigin) => new Promise((resolve, reject) => {
    const messageHandler = event => {
        switch (event.data.type) {
            case `RESULT_${type}`:
                resolve(event.data.data);
                window.removeEventListener('message', messageHandler);
                break
            default:
                break
        }
    }

    window.addEventListener('message', messageHandler);

    postMessageToParentWindow(parentWindow, type, payload, targetOrigin);
})

export {postMessageToParentWindowPromise}
